import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsApp = () => {
  const message = encodeURIComponent(
    "Hi, I'd like to know more about Epaging's enterprise solutions."
  );

  return (
    <a
      href={`https://wa.me/923435350202?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
      aria-label="Chat with Epaging on WhatsApp"
    >
      <FaWhatsapp aria-hidden="true" />
    </a>
  );
};

export default FloatingWhatsApp;
